import styled from '@emotion/styled';
import Footer from 'src/components/Footer';
import VividiLogo from 'src/components/VividiOnly/Logo';
const Wrap = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  flex-direction: column;
`;
const HeroSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
`;
const Logo = styled(VividiLogo)`
  width: 200px;
  height: auto;
`;
const VividiLandingPage = () => {
  return <Wrap data-sentry-element="Wrap" data-sentry-component="VividiLandingPage" data-sentry-source-file="index.tsx">
      <HeroSection data-sentry-element="HeroSection" data-sentry-source-file="index.tsx">
        <Logo data-sentry-element="Logo" data-sentry-source-file="index.tsx" />
      </HeroSection>
      <Footer data-sentry-element="Footer" data-sentry-source-file="index.tsx" />
    </Wrap>;
};
export default VividiLandingPage;